import { useState, useCallback } from 'react';
import { IRadioConfig, defaultState } from './RadioConfigContext';


export default function useRadioConfig() {
  const [radioConfig, setRadioConfigState] = useState<IRadioConfig>(defaultState);

  const setRadioConfig = useCallback((newRadioConfig) => {
    setRadioConfigState(newRadioConfig);
  }, []);

  return {
    radioConfig,
    setRadioConfig,
  }
}